import { render, staticRenderFns } from "./EWUserBalanceList.vue?vue&type=template&id=fd85bcca&"
import script from "./EWUserBalanceList.vue?vue&type=script&lang=js&"
export * from "./EWUserBalanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports